<template>
  <BaseExtractedDetails 
    :sections="sections" 
    :has-data="hasData"
    :data="data"
  />
</template>

<script>
import BaseExtractedDetails from './BaseExtractedDetails.vue'

export default {
  name: 'PayerListDetails',
  components: {
    BaseExtractedDetails
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasData() {
      return this.data && this.data.payers && this.data.payers.length > 0;
    },
    
    sections() {
      if (!this.hasData) return [];
      
      return [
        {
          title: 'Payer List Summary',
          icon: 'las la-list',
          type: 'summary-grid',
          cards: [
            {
              key: 'payers.length',
              label: 'Total Payers',
              format: 'number',
              highlight: true
            }
          ]
        },
        {
          title: 'Extracted Payers',
          icon: 'las la-users',
          type: 'list',
          items: this.data.payers.map((payer, index) => ({
            name: payer,
            number: index + 1
          })),
          fields: [
            {
              key: 'name',
              label: 'Payer Name',
              class: 'payer-name'
            }
          ]
        }
      ];
    }
  }
}
</script>

